var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('notification.error')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }